export const cz = {
    REQUIRED_ACTION_KeepCapturing: 'Pokračujte v zachycování.',
    REQUIRED_ACTION_PauseCapturing: 'Pozastavit zachytávání',
    REQUIRED_ACTION_Close: 'Zavřeno',
    REQUIRED_ACTION_Error: 'Chyba',
    REQUIRED_ACTION_AGREE: 'Souhlasím',
    REQUIRED_ACTION_DISAGREE: 'Nesouhlasím',
    LIVENESS_ACTION_Smile: 'Úsměv',
    LIVENESS_ACTION_Frown: 'Zamračit se',
    'LIVENESS_ACTION_Tilt Left': 'Podívej se doleva.',
    'LIVENESS_ACTION_Tilt Right': 'Podívej se doprava.',
    'LIVENESS_ACTION_Tilt Up': 'Podívej se nahoru.',
    'LIVENESS_ACTION_Tilt Down': 'Podívej dolů.',
    'LIVENESS_ACTION_Look Straight': 'Podívej se rovně před sebe.',
    'LIVENESS_ACTION_No Action': 'Žádná akce',
    LIVENESS_ACTION_PROCESSING_LIVENESS: 'Zpracování živosti',
    'LIVENESS_RESULT_Thank you!.Failed': 'Selhalo.',
    'LIVENESS_RESULT_Thank you!.Passed': 'Prošel',
    'LIVENESS_RESULT_Thank you!.ActionTimedOut': 'Akce vypršela',
    'LIVENESS_RESULT_Thank you!.Interrupted': 'Přerušeno',
    'LIVENESS_RESULT_Thank you!.Undefined': 'Nedefinovaný',
    LIVENESS_ACTION_LOOK_STRAIGHT_TITLE: 'Dívejte se přímo před sebe',
    LIVENESS_ACTION_LOOK_STRAIGHT_TEXT: 'Po celou dobu sledujte obrazovku',
    LIVENESS_ACTION_LOOK_LEFT_TITLE: 'Otáčejte hlavou mírně doleva',
    LIVENESS_ACTION_LOOK_LEFT_TEXT: 'Po celou dobu sledujte obrazovku',
    LIVENESS_ACTION_LOOK_RIGHT_TITLE: 'Otáčejte hlavou mírně doprava',
    LIVENESS_ACTION_LOOK_RIGHT_TEXT: 'Stále sledujte obrazovku',
    LIVENESS_ACTION_LOOK_UP_TITLE: 'Otáčejte hlavou mírně nahoru',
    LIVENESS_ACTION_LOOK_UP_TEXT: 'Stále mějte oči na obrazovce',
    LIVENESS_ACTION_LOOK_DOWN_TITLE: 'Otáčejte hlavou mírně dolů',
    LIVENESS_ACTION_LOOK_DOWN_TEXT: 'Stále mějte oči na obrazovce',
    LIVENESS_ACTION_SMILE_TITLE: 'Usmívejte se',
    LIVENESS_ACTION_SMILE_TEXT: 'Stále se dívejte na obrazovku',
    LIVENESS_ACTION_FROWN_TITLE: 'Mračte se',
    LIVENESS_ACTION_FROWN_TEXT: 'Po celou dobu mějte oči na obrazovce',
    PASSIVE_LIVENESS_ERROR_FACE_TOO_CLOSE_TITLE: 'Oh...Jsi příliš blízko.',
    PASSIVE_LIVENESS_ERROR_FACE_CLOSE_TO_BORDER_TITLE:
        'Oh...Jsi příliš blízko.',
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED_TITLE:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_FACE_CROPPED:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_FACE_NOT_FOUND_TITLE:
        'Nejsme schopni detekovat obličej na snímku. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_FACE_TOO_SMALL_TITLE: 'Uh...Jsi příliš daleko.',
    PASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE_TITLE: 'Uh...Něco se pokazilo.',
    ASSIVE_LIVENESS_ERROR_FACE_ANGLE_TOO_LARGE:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_TOO_MANY_FACES:
        'Nejsme schopni detekovat obličej na snímku. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_FACE_IS_OCCLUDED_TITLE:
        'Uh Oh...nejsme schopni detekovat obličej.',
    PASSIVE_LIVENESS_ERROR_UNKNOWN_TITLE: 'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_UNKNOWN: 'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_TITLE: 'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_INTERNAL:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD_TITLE: 'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_LOW_THRESHOLD:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_None_TITLE: 'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_None: 'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_FailedExpressions_TITLE: 'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_FailedExpressions:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_IMAGE_TITLE: 'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR_TITLE: 'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_IMAGE_ERROR:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR_TITLE: 'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_INTERNAL_ERROR:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE_TITLE:
        'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_WRITE_IMAGE:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL_TITLE: 'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_READ_MODEL:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE_TITLE: 'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_ALLOCATE:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG_TITLE: 'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_INVALID_CONFIG:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD_TITLE:
        'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_NO_SUCH_OBJECT_IN_BUILD:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT_TITLE:
        'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_PREDICT:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT_TITLE:
        'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREPROCESS_IMAGE_WHILE_DETECT:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS_TITLE:
        'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_FAILED_TO_PREDICT_LANDMARKS:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE_TITLE: 'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_INVALID_FUSE_MODE:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_NULLPTR_TITLE: 'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_NULLPTR: 'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR_TITLE: 'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_LICENSE_ERROR:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    PASSIVE_LIVENESS_ERROR_INVALID_META_TITLE: 'Uh...Něco se pokazilo.',
    PASSIVE_LIVENESS_ERROR_INVALID_META:
        'Něco se pokazilo. Zkuste to prosím znovu.',
    INITIALIZING_TITLE: 'Inicializace',
    INITIALIZING_DESCRIPTION:
        'Kontrola hardwarových schopností, prosím čekejte...',
    JOURNEY_STATE_STARTED: 'Začalo',
    JOURNEY_STATE_INPROGRESS: 'V průběhu.',
    JOURNEY_STATE_ENDED: 'Skončil',
    INFO_JOURNEY_STATE: 'Stát',
    INFO_JOURNEY_ACTION: 'Akce',
    INFO_JOURNEY_ACTION_ATTEMPT: 'Pokus o akci',
    INFO_JOURNEY_ID: 'ID cesty',
    INFO_JOURNEY_RESULT: 'Výsledek',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE: 'Zpráva o výsledku',
    RESULTS_HIGH_LEVEL_EXPIRED_MESSAGE_VALUE:
        'To ID, které jste nám dal, bylo zastaralé – zkuste něco jiného',
    INFO_JOURNEY_REFERENCE: 'Reference',
    FLOW_STATE_NONE: 'Žádný',
    'FLOW_STATE_IDENTITY:FRONT': 'Přední strana',
    'FLOW_STATE_IDENTITY:BACK': 'Zadní strana',
    FLOW_STATE_ADDRESS: 'Adresa',
    FLOW_STATE_SELFIE: 'Autoportrét',
    FLOW_STATE_LIVENESS: 'Živost',
    FLOW_STATE_COVID: 'Covid',
    PROVIDER_TITLE_CAMERA: 'Kamera',
    PROVIDER_TITLE_CROPPER: 'Úpravce',
    PROVIDER_TITLE_FILESYSTEM_ID:
        'Nahrajte fotografii svého dokladu totožnosti',
    PROVIDER_TITLE_FILESYSTEM_FACEMATCH: 'Nahrajte svou fotku',
    PROVIDER_TITLE_FILESYSTEM_ADDRESS:
        'Nahrajte fotografii svého dokladu o adrese',
    PROVIDER_TITLE_FILESYSTEM_COVID:
        'Nahrajte fotografii svého dokumentu Covid',
    PROVIDER_TITLE_GATEWAY: 'Brána',
    PROVIDER_TITLE_LIVENESS: 'Živost',
    PROVIDER_TITLE_LOGIN: 'Přihlášení',
    PROVIDER_TITLE_RESULTS: 'Výsledky',
    PROVIDER_TITLE_SCANNER: 'Naskenujte svůj doklad totožnosti',
    PROVIDER_TITLE_VIEW_ID: 'Zkontrolujte náhled svého dokladu totožnosti',
    PROVIDER_TITLE_VIEW_FACEMATCH: 'Zkontrolujte náhled své selfie',
    PROVIDER_TITLE_VIEW_ADDRESS: 'Zkontrolujte náhled svého dokladu o adrese',
    ROVIDER_TITLE_VIEW_COVID: 'Zkontrolujte náhled svého Covidu',
    PROVIDER_SUBTITLE_FILESYSTEM_ID:
        'Nahrajte prosím fotografii svého dokladu totožnosti, která je jasná, zaostřená, nezakrytá a přímo položená lícem.',
    PROVIDER_SUBTITLE_FILESYSTEM_FACEMATCH:
        'Nahrajte prosím svou fotku, která je jasná, zaostřená, nezakrytá a přímo otočená obličejem',
    PROVIDER_SUBTITLE_FILESYSTEM_ADDRESS:
        'Nahrajte fotku svého dokumentu, která je jasná, zaostřená, nezakrytá a přímo otočená lícem.',
    PROVIDER_SUBTITLE_FILESYSTEM_COVID:
        'Nahrajte fotku svého dokumentu, která je jasná, zaostřená, nezakrytá a přímo otočená lícem.',
    PROVIDER_SUBTITLE_SCANNER_ID:
        'Umístěte stránku s fotografií vašeho průkazu totožnosti lícem dolů na skener.',
    PROVIDER_SUBTITLE_VIEW_ID:
        'Zkontrolujte, zda je náhled vašeho dokumentu jasný, zaostřený, nezakrytý a přímo na něj lícem.',
    PROVIDER_SUBTITLE_VIEW_FACEMATCH:
        'Zkontrolujte, zda je náhled vašeho selfie jasný, zaostřený, nezakrytý a přímo otočený obličejem.',
    PROVIDER_SUBTITLE_VIEW_ADDRESS:
        'Zkontrolujte, zda je náhled vašeho dokumentu jasný, zaostřený, nezakrytý a přímo na něj lícem.',
    PROVIDER_SUBTITLE_VIEW_COVID:
        'Zkontrolujte, zda je náhled vašeho dokumentu jasný, zaostřený, nezakrytý a přímo na něj lícem.',
    PROVIDER_TITLE_SMART_CAPTURE: 'Chytrý zachycení',
    PROVIDER_TITLE_JOURNEY_SELECT: 'Vyberte cestu',
    PROVIDER_TITLE_TERMS_AND_CONDITIONS: 'Smluvní podmínky',
    PROVIDER_TITLE_USER_INPUT: 'Vyplňte prosím následující formulář',
    FILESYSTEM_SUPPORTED_TYPES_FIRST: 'Přijímané formáty:',
    FILESYSTEM_SUPPORTED_TYPES_LIST: 'JPG, PNG',
    FILESYSTEM_SUPPORTED_TYPES_START_SELFIE: 'Přijímané formáty: JPG, PNG',
    FILESYSTEM_MAX_FILE_SIZE:
        'Velikost souboru: přijímáme jakoukoli velikost souboru menší než',
    FILESYSTEM_MAX_FILE_SIZE_NUMBER: '7,5 MB',
    FILESYSTEM_CHECK_FILE_TOO_BIG:
        'Váš soubor je příliš velký. Nahrajte soubor, který je menší než 7,5 MB.',
    FILESYSTEM_CHECK_FILE_INCORRECT_FORMAT:
        'Váš soubor má nesprávný formát. Nahrajte prosím jeden z akceptovaných formátů.',
    FILESYSTEM_IDENTITY_DOCUMENT: 'Doklad totožnosti',
    FILESYSTEM_FACEMATCH: 'Face Match',
    FILESYSTEM_ADDRESS: 'Doklad o adrese',
    FILESYSTEM_COVID: 'Covid',
    FILESYSTEM_DRAG_DROP: 'Drag and Drop',
    FILESYSTEM_OR: 'nebo',
    FILESYSTEM_CHOOSE: 'Vyberte soubor',
    FILESYSTEM_UPLOADING: 'Nahrávání...',
    TRIPLESCAN_GUIDANCE_TRYAGAIN: 'Zkuste to znovu',
    FAILURE_REASON_REFER: 'Váš doklad totožnosti neprošel ověřením.',
    FAILURE_REASON_EXPIRED: 'Platnost vašeho dokladu totožnosti vypršela.',
    FAILURE_REASON_NOT_ACCEPTED:
        'Váš doklad totožnosti není akceptovaným typem dokladu.',
    FAILURE_REASON_NOT_SUPPORTED:
        'Váš doklad totožnosti nelze klasifikovat nebo není podporován.',
    PLEASE_TRY_AGAIN_REFER: 'Zkuste to prosím znovu.',
    PLEASE_TRY_AGAIN_EXPIRED: 'Zkuste to znovu s platným dokumentem.',
    PLEASE_TRY_AGAIN_NOT_ACCEPTED: 'Zkuste to znovu s jiným dokumentem.',
    PLEASE_TRY_AGAIN_NOT_SUPPORTED: 'Zkuste to prosím znovu.',
    BLUR_CHECK_REASON: 'Rozostření – dokument je nejasný;',
    GLARE_CHECK_REASON:
        'Oslnění – dokument je nečitelný kvůli silnému zdroji světla;',
    RESOLUTION_CHECK_REASON:
        'Nízké rozlišení – dokument nevyplňuje správně rámeček;',
    EDGES_CHECK_REASON:
        'Chybějící okraje – dokument není správně umístěn v rámečku;',
    VALIDATION_FAILED: 'Ověření se nezdařilo',
    VALIDATION_FAILED_REASON_DOC_UNKNOWN: '- dokument neznámý.',
    VALIDATION_FAILED_REASON_DOC_NOT_ACCEPTED: '- dokument nebyl přijat.',
    VALIDATION_FAILED_REASON_DOC_EXPIRED: '- platnost dokumentu vypršela.',
    PREVIEW_INFO_TITLE_ID: 'Příklady dobrých a špatných fotografií',
    PREVIEW_INFO_GOOD: 'Dobrý',
    PREVIEW_INFO_BAD: 'Špatný',
    PREVIEW_INFO_GOOD_EXAMPLE_ID:
        'Fotografie je jasná, zaostřená a přímo na ní.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ID:
        'Fotografie musí zobrazovat všechny čtyři rohy.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ID: 'Dokument nesmí být zakrytý.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ID: 'Fotografie nesmí být rozmazaná.',
    PREVIEW_INFO_TITLE_FACEMATCH: 'Tipy na kvalitní selfie',
    PREVIEW_INFO_GOOD_EXAMPLE_FACEMATCH:
        'Selfie je jasné, zaostřené a přímo na ní.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_FACEMATCH:
        'Selfie musí ukazovat celou tvář.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_FACEMATCH: 'Obličej nesmí být zakrytý.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_FACEMATCH: 'Selfie nesmí být rozmazané.',
    PREVIEW_INFO_TITLE_ADDRESS: 'Tipy pro kvalitní fotografii',
    PREVIEW_INFO_GOOD_EXAMPLE_ADDRESS:
        'Fotografie je jasná, zaostřená a přímo na ní.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_ADDRESS:
        'Fotografie musí zobrazovat všechny čtyři rohy.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_ADDRESS: 'Dokument nesmí být zakrytý.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_ADDRESS: 'Fotografie nesmí být rozmazaná.',
    PREVIEW_INFO_TITLE_COVID: 'Tipy pro kvalitní fotografii',
    PREVIEW_INFO_GOOD_EXAMPLE_COVID:
        'Fotografie je jasná, zaostřená a přímo na ní.',
    PREVIEW_INFO_BAD_EXAMPLE_ANGLE_COVID:
        'Fotografie musí zobrazovat všechny čtyři rohy.',
    PREVIEW_INFO_BAD_EXAMPLE_COVER_COVID: 'Dokument nesmí být zakrytý.',
    PREVIEW_INFO_BAD_EXAMPLE_BLUR_COVID: 'Fotografie nesmí být rozmazaná.',
    ATTEMPTS_REMAINING: 'Počet zbývajících pokusů:',
    CAMERA_CAPTURE: 'Zapněte kameru',
    CAMERA_CAPTURE_START_BUTTON: 'Spusťte Auto Capture',
    CAMERA_CAPTURE_CAPTION: 'Začněte kliknutím na Start Auto Capture',
    CAMERA_PREVIEW_START: 'Zapněte fotoaparát a spusťte Auto Capture',
    CAMERA_CONDITION_BLUR: 'Bylo zjištěno rozmazání',
    CAMERA_CONDITION_CAPTURING: 'Snímání',
    CAMERA_CONDITION_UPLOADING: 'Nahrávání...Počkejte prosím',
    CAMERA_CONDITION_ALIGNMENT: 'Dokument není v rámu',
    CAMERA_CONDITION_GLARE: 'Zjištěno oslnění',
    VERIFYING_TITLE: 'Ověřování...',
    PREPARING_PREVIEW_TITLE: 'Příprava náhledu...',
    CAMERA_CONDITION_LOW_RESOLUTION: 'Dokument je příliš daleko',
    CAMERA_LOADING: 'Otevírání fotoaparátu...',
    CAMERA_SMARTCAPTURE_ON: 'AUTOMATICKÉ SNÍMÁNÍ - ZAPNUTO',
    CAMERA_SMARTCAPTURE_OFF: 'AUTOMATICKÉ SNÍMÁNÍ - VYPNUTO',
    CAMERA_CAPTURE_FRONT:
        'Umístěte stranu s fotografií vašeho dokladu totožnosti do rámečku níže.',
    CAMERA_MANUAL_CAPTURE_FRONT:
        'Umístěte svůj doklad totožnosti do rámečku a klikněte na tlačítko níže',
    CAMERA_CAPTURE_BACK:
        'Umístěte ZADNÍ STRANU vašeho průkazu totožnosti do rámečku',
    CAMERA_CAPTURE_SELFIE_CAPTION:
        'Umístěte svůj obličej do oválu, podívejte se přímo do fotoaparátu a kliknutím na tlačítko níže pořiďte selfie.',
    CAMERA_CAPTURE_ADDRESS_CAPTION:
        'Umístěte svůj doklad o adrese do rámečku a kliknutím na tlačítko níže pořiďte fotografii.',
    CAMERA_CAPTURE_COVID_CAPTION:
        'Umístěte dokument Covid do rámečku a kliknutím na tlačítko níže pořiďte fotografii.',
    CAMERA_PREVENT_GLARE_HINT:
        'Přesuňte dokument dále od přímých zdrojů světla.',
    CAMERA_PREVENT_BLUR_HINT: 'Držte dokument nebo zařízení pevně.',
    CAMERA_PREVENT_LOW_RES_HINT: 'Vložte dokument zcela do rámečku.',
    CROPPER_RETRY: 'Zkuste to znovu',
    CROPPER_UPLOAD: 'Nahrát',
    CROPPER_UPLOADING: 'Nahrávání...',
    FILESYSTEM_SELECT: 'Vybrat',
    FILESYSTEM_DROP_IMAGE: 'nebo Drop Image',
    GATEWAY_CAMERA: 'Kamera povolena',
    GATEWAY_CANCEL: 'Zrušit cestu',
    LIVENESS_START: 'Spusťte Živost',
    PASSIVE_LIVENESS_START: 'Pořídit snímek',
    LOGIN_USERNAME: 'Uživatelské jméno',
    LOGIN_PASSWORD: 'Heslo',
    LOGIN_SUBMIT: 'Odeslat',
    RESULTS_DOCUMENTS: 'Dokumenty',
    RESULTS_DOCUMENTS_NONE: 'Žádné nenalezeno',
    RESULTS_DOCUMENT_TYPE: 'Typ dokumentu',
    RESULTS_DOCUMENT_RESULT: 'Výsledek dokumentu',
    RESULTS_EXTRACTED_FIELDS_NONE: 'Podrobnosti o výsledku',
    RESULTS_DETAILS_NONE: 'Žádné nenalezeno',
    RESULTS_NEW_JOURNEY: 'Začněte novou cestu',
    RESULTS_NO_INFORMATION: 'Pro tuto cestu nejsou žádné informace',
    RESULTS_LOGOUT: 'Odhlásit se',
    RESULTS_HIGH_LEVEL_Aborted: 'Přerušeno',
    RESULTS_HIGH_LEVEL_TCCDISAGREE: "Zrušené T&C's",
    RESULTS_HIGH_LEVEL_Expired: 'Vypršel.',
    RESULTS_HIGH_LEVEL_NotAccepted: 'Nepřijato',
    RESULTS_HIGH_LEVEL_NotSupported: 'Nepodporováno',
    RESULTS_HIGH_LEVEL_Notsupported: 'Nepodporováno',
    RESULTS_HIGH_LEVEL_Passed: 'Prošel',
    RESULTS_HIGH_LEVEL_Refer: 'Odkaz',
    RESULTS_HIGH_LEVEL_Undefined: 'Nedefinovaný',
    RESULTS_HIGH_LEVEL_DETAIL_ACCUMULATIVELIVENESSRESULT:
        'Kumulativní výsledek životnosti',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTFRONTSIDETYPECHECK:
        'Kontrola typu přední strany dokumentu',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBACKSIDECHECK:
        'Zadní strana dokumentu Kontrola',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTBLOCKINGPOLICY:
        'Politika blokování dokumentů',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTEXPIRY: 'Platnost dokumentu',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTSUPPORT: 'Podpora dokumentů',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTVALIDATION: 'Ověření dokumentu',
    RESULTS_HIGH_LEVEL_DETAIL_DOCUMENTPROOFPOLICY:
        'Politika důkazních dokumentů',
    RESULTS_HIGH_LEVEL_DETAIL_FACEMATCHVALIDATION: 'Ověření Facematch',
    RESULTS_HIGH_LEVEL_DETAIL_UNDERAGERULE: 'Pravidlo pro nezletilé',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_SUCCESS_NEEDED: 'Potřebný úspěch',
    RESULTS_HIGH_LEVEL_DETAIL_COVID_PASS_CROSSCHECK:
        'Kontrola kompatibility pasu Covid',
    RESULTS_HIGH_LEVEL_DETAIL_DATA_CHECK: 'Kontroly dat',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_FAILED: 'Selhalo.',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_NOTNEEDED: 'Není potřeba.',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_PASSED: 'Prošel',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_SKIPPED: 'Přeskočeno',
    RESULTS_HIGH_LEVEL_DETAIL_VALUE_UNDETERMINED: 'Neurčeno',
    ADDITIONAL_CHECKS_DETAILS: 'Další kontroly',
    ADDITIONAL_CHECKS_DETAILS_NONE: 'Nebyly nalezeny',
    ADDITIONAL_CHECKS_DETAIL_DATACHECKS: 'Kontroly dat',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK: 'Zpětné kontroly',
    ADDITIONAL_CHECKS_DETAIL_LOOKBACKCHECK_NA: 'NEUPLATŇUJE SE',
    GBG_SCORES: 'Skóre GBG',
    GBG_TRUST_SCORE: 'Skóre důvěryhodnosti GBG',
    GBG_SCORE: 'Skóre GBG',
    PREVIEW_TITLE: 'Je váš dokument jasný a ostrý?',
    VIEW_RETRY: 'ZNOVU VYFOŤTE',
    VIEW_RETRY_DESKTOP: 'Fotografie změny',
    VIEW_CROP: 'Úroda',
    VIEW_CROPPING: 'Ořezávání...',
    VIEW_UPLOAD: 'Nahrát',
    VIEW_UPLOAD_PREVIEW: 'ANO, POKRAČOVAT',
    VIEW_UPLOADING: 'Nahrávání...',
    SMART_CAPTURE_INITIALIZING: 'Začátek',
    SMART_CAPTURE_START: 'Inicializace Smart Capture, Prosím čekejte...',
    SCANNER_DESC_AVAILABLE:
        'Skenér je k dispozici. Umístěte svůj dokument do skeneru.',
    SCANNER_DESC_PROCESSING: 'Obrázek je zpracováván serverem.',
    SCANNER_DESC_SCANNING: 'Obrázek je skenován zařízením.',
    SCANNER_DESC_DISCONNECTED: 'Skenovací zařízení je odpojeno od sítě.',
    SCANNER_DESC_NOT_CONNECTED: 'Skenovací zařízení není připojeno.',
    SCANNER_DESC_OFFLINE: 'Skenovací zařízení je offline.',
    SCANNER_DESC_BUSY:
        'Skenovací zařízení je používáno jiným uživatelem ve vaší lokální síti.',
    SCANNER_DESC_WAITING: 'Čekání na navázání spojení.',
    SCANNER_DESC_LOADING: 'Prosím čekejte...',
    SCANNER_TITLE_SCANNING: 'Skenování...',
    SCANNER_TITLE_DISCONNECTED: 'ODPOJENÝ',
    SCANNER_TITLE_NOT_CONNECTED: 'NENAVÁZÁNO',
    SCANNER_TITLE_OFFLINE: 'Skener offline',
    SCANNER_TITLE_BUSY: 'Skener je zaneprázdněn',
    SCANNER_TITLE_WAITING: 'ČEKÁNÍ',
    SCANNER_ACTION_REGISTER: 'Registrace',
    SCANNER_ACTION_RELEASE: 'Uvolnění',
    CANCEL_JOURNEY: 'Zrušit',
    MANUAL_PHOTO_UPLOAD_TOGGLE_FALSE: 'Nahrajte místo toho fotografii',
    MANUAL_PHOTO_UPLOAD_TOGGLE_TRUE: 'Pořiďte místo toho fotografii',
    JOURNEY_SELECT_CONTINUE: 'Pokračovat na',
    HELP_MODAL_AUTOCAPTURE_TITLE: 'Jak vyfotit doklad totožnosti',
    HELP_MODAL_AUTOCAPTURE_SUBTITLE:
        'Je-li zapnuta funkce automatického snímání, obrazovka snímání automaticky pořídí fotografii vašeho dokladu, jakmile rozpozná, že je dostatečně kvalitní.',
    HELP_MODAL_AUTOCAPTURE_TIPS: 'Tipy pro pořízení kvalitní fotografie',
    HELP_MODAL_AUTOCAPTURE_GLARE_TITLE: 'Zabraňte oslnění',
    HELP_MODAL_AUTOCAPTURE_GLARE_SUBTITLE:
        'Přemístěte dokument mimo dosah přímých zdrojů světla.',
    HELP_MODAL_AUTOCAPTURE_FAR_TITLE: 'Příliš vzdálený dokument',
    AUTOCAPTURE_FAR_SUBTITLE: 'Vložte dokument zcela do rámečku.',
    AUTOCAPTURE_BLUR_TITLE: 'Zabránit rozmazání',
    HELP_MODAL_AUTOCAPTURE_BLUR_SUBTITLE:
        'Držte dokument nebo zařízení v klidu.',
    HELP_MODAL_AUTOCAPTURE_MANUAL_CAPTURE:
        'Stále máte potíže? Pořiďte fotografii pomocí ručního snímání',
    HELP_MODAL_AUTOCAPTURE_TURN_MANUAL_CAPTURE: 'Ruční snímání',
    HELP_MODAL_SELFIE_TITLE: 'Jak pořídit selfie',
    HELP_MODAL_SELFIE_SUBTITLE:
        'Podívejte se přímo do fotoaparátu a klikněte na tlačítko ručního snímání.',
    HELP_MODAL_POA_TITLE: 'Jak vyfotit doklad o adrese',
    HELP_MODAL_POA_SUBTITLE:
        'Umístěte doklad do rámečku a kliknutím na tlačítko zachycení pořiďte fotografii dokladu.',
    HELP_MODAL_POA_TIPS: 'Tipy pro pořízení kvalitní fotografie',
    HELP_MODAL_POA_GLARE_TITLE: 'Zabraňte oslnění',
    HELP_MODAL_POA_GLARE_SUBTITLE:
        'Přemístěte dokument mimo dosah přímých zdrojů světla.',
    HELP_MODAL_POA_FAR_TITLE: 'Příliš vzdálený dokument',
    HELP_MODAL_POA_FAR_SUBTITLE: 'Umístěte dokument zcela do rámečku.',
    HELP_MODAL_POA_BLUR_TITLE: 'Zabraňte rozmazání',
    HELP_MODAL_POA_BLUR_SUBTITLE: 'Držte dokument nebo zařízení v klidu.',
    HELP_MODAL_POA_MANUAL_CAPTURE: 'Stále máte potíže? Zapněte ruční snímání',
    HELP_MODAL_POA_TURN_MANUAL_CAPTURE: 'Ruční snímání',
    HELP_MODAL_COVID_TITLE: 'Jak vyfotografovat dokument Covid',
    HELP_MODAL_COVID_SUBTITLE:
        'Umístěte dokument do rámečku a kliknutím na tlačítko zachycení pořiďte fotografii dokumentu.',
    HELP_MODAL_COVID_TIPS: 'Tipy pro pořízení kvalitní fotografie',
    HELP_MODAL_COVID_GLARE_TITLE: 'Zabraňte oslnění',
    HELP_MODAL_COVID_GLARE_SUBTITLE:
        'Přesuňte dokument mimo dosah přímých zdrojů světla.',
    HELP_MODAL_COVID_FAR_TITLE: 'Příliš vzdálený dokument',
    HELP_MODAL_COVID_FAR_SUBTITLE: 'Vměstnejte dokument zcela do rámečku.',
    HELP_MODAL_COVID_BLUR_TITLE: 'Zabránit rozmazání',
    HELP_MODAL_COVID_BLUR_SUBTITLE: 'Držte dokument nebo zařízení v klidu.',
    HELP_MODAL_COVID_MANUAL_CAPTURE: 'Stále máte potíže? Zapněte ruční snímání',
    HELP_MODAL_COVID_TURN_MANUAL_CAPTURE: 'Ruční snímání',
    HELP_MODAL_NEED_HELP: 'Pomoc a možnosti',
    EXCEPTION: 'Došlo k neočekávané výjimce',
    EXCEPTION_AUTHORIZATION: 'Neautorizované',
    EXCEPTION_AUTHORIZATION_ACCOUNT_NOT_AUTHORIZED:
        'Váš účet není oprávněn k přístupu k tomuto zdroji',
    EXCEPTION_AUTHORIZATION_AUTH_DETAILS_INVALID:
        'Kombinace uživatelského jména a hesla není platná',
    EXCEPTION_AUTHORIZATION_AUTH_NOT_ENABLED:
        'Chcete-li tuto funkci používat, musíte povolit ověřování',
    EXCEPTION_AUTHORIZATION_PROCESS_NOT_AUTHORIZED:
        'Nejste oprávněni k tomuto procesu',
    EXCEPTION_BAD_REQUEST: 'Špatný požadavek se stavovým kódem 400',
    EXCEPTION_BAD_REQUEST_INVALID_IMAGE: 'Není platný obrázek',
    EXCEPTION_BAD_REQUEST_WAITING_FOR_RESPONSE: 'Cesta čeká na odpověď',
    EXCEPTION_FLOW_STATE_JOURNEY_ENDED:
        'Nelze odeslat požadavky. Cesta byla ukončena',
    EXCEPTION_FLOW_STATE_MISSING: 'Stav toku nebyl nalezen',
    EXCEPTION_INVALID_PARAMETER_CALLBACK_MUST_BE_FUNCTION:
        'Callback musí být platná funkce.',
    EXCEPTION_INVALID_PARAMETER_NAME_MUST_BE_STRING:
        'Název události musí být řetězcová hodnota',
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_NUMBER:
        'Priorita musí být číslo.',
    EXCEPTION_INVALID_PARAMETER_PRIORITY_MUST_BE_POSITIVE_NUMBER:
        'Priorita musí být kladné číslo.',
    EXCEPTION_INVALID_PARAMETER_SHOULD_BE_ELEMENT_OR_SELECTOR:
        'Kontejner by měl být buď prvek nebo selektor',
    EXCEPTION_INVALID_PARAMETER_VALUE_NOT_VALID: 'Hodnota není platná.',
    EXCEPTION_INVALID_PARAMETER_VALUE_DAMAGED: 'Hodnota byla poškozena.',
    EXCEPTION_MISSING_PARAMETER_BACKEND_URL_MISSING:
        'Konfigurace by měla zahrnovat parametr backendUrl.',
    EXCEPTION_MISSING_PARAMETER_COORDINATES_MISSING:
        'Poskytnuté parametry musí obsahovat souřadnice.',
    EXCEPTION_MISSING_PARAMETER_IMAGES_MISSING:
        'Poskytnuté parametry musí obsahovat obrázky.',
    EXCEPTION_MISSING_PARAMETER_PASSWORD_MISSING:
        'Poskytnuté parametry by měly obsahovat heslo.',
    EXCEPTION_MISSING_PARAMETER_USERNAME_MISSING:
        'Poskytnuté parametry by měly obsahovat uživatelské jméno.',
    EXCEPTION_MISSING_REQUIRED_FIELD_MISSING:
        'Vyplňte prosím všechna povinná pole',
    EXCEPTION_POSTCODE_FORMAT_ERROR:
        'Formát poštovního směrovacího čísla není platný minLength:5 / maxLength:8',
    EXCEPTION_HOUSENUMBER_FORMAT_ERROR:
        'Formát názvu domu/čísla není platný minDélka:1 / maxDélka:20',
    EXCEPTION_STREETNAME_FORMAT_ERROR:
        'Název ulice není platný minDélka:1 / maxDélka:30',
    EXCEPTION_TOWN_FORMAT_ERROR:
        'Formát obce není platný minDélka:1 / maxDélka:20',
    EXCEPTION_JOURNEY_DEFINITIONS_MISSING:
        'Pro tento kanál nejsou k dispozici žádné definice cesty',
    EXCEPTION_NETWORK:
        'Došlo k síťové výjimce, zkontrolujte prosím své připojení a zkuste to znovu.',
    EXCEPTION_PLATFORM_BROWSER_ONLY:
        'Tuto funkci lze použít pouze v prohlížeči',
    EXCEPTION_PLATFORM_UNSUPPORTED: 'Vaše prostředí tuto funkci nepodporuje',
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_DENIED:
        'Nebyla udělena oprávnění ke kameře, zkontrolujte prosím nastavení prohlížeče',
    EXCEPTION_PLATFORM_CAMERA_PERMISSION_UNAVAILABLE:
        'Oprávnění ke kameře nejsou k dispozici',
    EXCEPTION_PLATFORM_CAMERA_NOT_READABLE:
        'Ke kameře se nepodařilo získat přístup. Zavřete prosím všechny ostatní aplikace a zkuste to znovu',
    EXCEPTION_PLATFORM_CAMERA_NONE_SUITABLE:
        'Ve vašem zařízení nebyly nalezeny žádné vhodné fotoaparáty',
    EXCEPTION_SERVER: 'Požadavek se nezdařil se stavovým kódem 500',
    EXCEPTION_SERVER_UNREACHABLE: 'Požadavek se nezdařil, server je nedostupný',
    EXCEPTION_SERVER_DATA_NOT_PERSISTED:
        'Během procesu došlo k chybě. Vaše data nemusí být zachována',
    EXCEPTION_SERVER_RESULT_NOT_PASSING: 'Aktuální výsledek neprošel',
    EXCEPTION_TEMPLATE_CANVAS_CONTEXT_UNAVAILABLE:
        'Kontext plátna není k dispozici',
    EXCEPTION_TEMPLATE_CONTAINER_MISSING: 'Kontejner není přítomen',
    EXCEPTION_TEMPLATE_ELEMENTS_MISSING: 'Chybí požadované prvky',
    EXCEPTION_TEMPLATE_MISSING: 'Šablona nebyla nalezena',
    EXCEPTION_TEMPLATE_SOURCE_ELEMENT_MISSING: 'Nelze najít zdrojový prvek',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_CANNOT_RETRIEVE:
        'Nelze získat poskytovatele vstupů',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NONE_SPECIFIED:
        'Nejsou zadáni žádní poskytovatelé vstupů',
    EXCEPTION_UNAVAILABLE_INPUT_PROVIDER_NOT_AVAILABLE:
        'Poskytovatel vstupů není k dispozici',
    'SUPPORTED_DOCUMENT_Account Statement': 'Výpis účtu',
    'SUPPORTED_DOCUMENT_Agreement (Tenancy)': 'Smlouva (Pronájem)',
    'SUPPORTED_DOCUMENT_Bank Document': 'Bankovní dokument',
    'SUPPORTED_DOCUMENT_Bank Letter': 'Bankovní dopis',
    'SUPPORTED_DOCUMENT_Bank Statement': 'Výpis z účtu',
    'SUPPORTED_DOCUMENT_Benefit Letter': 'Příjemný dopis',
    'SUPPORTED_DOCUMENT_Certificate (Birth, Marriage, Civil partnership)':
        'Osvedčení (Narození, Manželství, Občanské partnerství)',
    'SUPPORTED_DOCUMENT_Council Document': 'Dokument rady',
    'SUPPORTED_DOCUMENT_Council Letter': 'List rady',
    'SUPPORTED_DOCUMENT_Council Tax': 'Daň z nemovitostí',
    'SUPPORTED_DOCUMENT_Driving License': 'Řidičský průkaz',
    'SUPPORTED_DOCUMENT_Driving Licence': 'Řidičský průkaz',
    'SUPPORTED_DOCUMENT_DWP Document': 'Dokument DWP',
    'SUPPORTED_DOCUMENT_HMRC Document': 'Dokument HMRC',
    'SUPPORTED_DOCUMENT_Information Sheet': 'Informační list',
    'SUPPORTED_DOCUMENT_Insurance Document': 'Dokument o pojištění',
    'SUPPORTED_DOCUMENT_Insurance Letter': 'Pojišťovací dopis',
    SUPPORTED_DOCUMENT_Invoice: 'Faktura',
    'SUPPORTED_DOCUMENT_NIC Letter': 'Dopis NIC',
    'SUPPORTED_DOCUMENT_NINO Letter': 'NINO Dopis',
    'SUPPORTED_DOCUMENT_Official Document': 'Oficiální dokument',
    'SUPPORTED_DOCUMENT_Official Letter': 'Oficiální dopis',
    'SUPPORTED_DOCUMENT_Repayment Letter (related to Tax or Social support)':
        'Dopis o splacení (týkající se daní nebo sociální podpory)',
    'SUPPORTED_DOCUMENT_Tax Letter': 'Daňový dopis',
    'SUPPORTED_DOCUMENT_Tax Statement': 'Daňové přiznání',
    'SUPPORTED_DOCUMENT_Tel Bill': 'Telefonní účet.',
    'SUPPORTED_DOCUMENT_Tel Letter': 'Tel dopis',
    'SUPPORTED_DOCUMENT_Telecommunication Document': 'Telekomunikační dokument',
    'SUPPORTED_DOCUMENT_TV Licence': 'Televizní licence',
    'SUPPORTED_DOCUMENT_University Letter': 'Univerzitní dopis',
    'SUPPORTED_DOCUMENT_Utility Bill': 'Účet za služby',
    'SUPPORTED_DOCUMENT_Utility Document': 'Užitný dokument',
    'SUPPORTED_DOCUMENT_Utility Letter': 'Užitkový dopis',
    'SUPPORTED_DOCUMENT_Water Bill': 'Vodní účet',
    'SUPPORTED_DOCUMENT_Water Document': 'Vodní dokument',
    'SUPPORTED_DOCUMENT_Agents License': 'Licence agenta',
    'SUPPORTED_DOCUMENT_Electoral Card': 'Volební průkaz',
    'SUPPORTED_DOCUMENT_Foreigner Identification Card': 'Průkaz cizince',
    'SUPPORTED_DOCUMENT_Health Card': 'Zdravotní průkaz',
    'SUPPORTED_DOCUMENT_Job License': 'Pracovní licence',
    'SUPPORTED_DOCUMENT_Membership Identification Card': 'Průkaz členství',
    'SUPPORTED_DOCUMENT_Military Identification Card': 'Vojenský průkaz',
    'SUPPORTED_DOCUMENT_National Identification Card':
        'Národní průkaz totožnosti',
    SUPPORTED_DOCUMENT_Passport: 'Pas',
    'SUPPORTED_DOCUMENT_Travel Permit': 'Cestovní povolení',
    SUPPORTED_DOCUMENT_Visa: 'Vízum',
    'SUPPORTED_DOCUMENT_Weapons Licence': 'Zbrojní průkaz',
    'SUPPORTED_DOCUMENT_Selfie Photo': 'Fotka selfie',
    SUPPORTED_DOCUMENT_Unknown: 'Neznámý',
    SUPPORTED_DOCUMENT_COVIDPAS: 'Průkaz Covid',
    EXTRACTED_FIELDS_AddressFull: 'Adresa plná',
    EXTRACTED_FIELDS_AddressCity: 'Adresa Město',
    EXTRACTED_FIELDS_AddressPostCode: 'Adresa PSČ',
    EXTRACTED_FIELDS_LastNameFirstPart: 'Příjmení První část',
    EXTRACTED_FIELDS_Sex: 'Gender',
    EXTRACTED_FIELDS_BirthPlace: 'Místo narození',
    EXTRACTED_FIELDS_IssueNumber: 'Číslo vydání',
    EXTRACTED_FIELDS_DocumentNumberCheckDigit:
        'Kontrolní číslice čísla dokumentu',
    EXTRACTED_FIELDS_BirthDate: 'Datum narození',
    EXTRACTED_FIELDS_DocumentNumber: 'Číslo dokumentu',
    EXTRACTED_FIELDS_FirstName: 'Křestní jméno',
    EXTRACTED_FIELDS_ArbitraryDigit: 'Libovolné číslice',
    EXTRACTED_FIELDS_FirstNameInitial: 'Iniciálka křestního jména',
    EXTRACTED_FIELDS_ExpiryDate: 'Datum vypršení',
    EXTRACTED_FIELDS_IssueDate: 'Datum vydání',
    EXTRACTED_FIELDS_LastName: 'Příjmení',
    EXTRACTED_FIELDS_LicenseCategory: 'Kategorie licence',
    EXTRACTED_FIELDS_DocumentCategory: 'Kategorie dokumentu',
    EXTRACTED_FIELDS_DocumentType: 'Typ dokumentu',
    EXTRACTED_FIELDS_NationalityCode: 'Národnostní kód',
    EXTRACTED_FIELDS_MiddleName: 'Druhé jméno',
    EXTRACTED_FIELDS_FirstIssuanceDate: 'První datum vydání',
    EXTRACTED_FIELDS_SecondLastName: 'Druhé příjmení',
    EXTRACTED_FIELDS_FullName: 'Celé jméno',
    EXTRACTED_FIELDS_PersonalNumber: 'Osobní číslo',
    EXTRACTED_FIELDS_NationalityName: 'Národnost',
    EXTRACTED_FIELDS_BarcodeItems: 'Čárový kód',
    EXTRACTED_FIELDS_BirthPlaceCity: 'Město narození',
    EXTRACTED_FIELDS_BirthPlaceState: 'Stav narození',
    EXTRACTED_FIELDS_BirthPlaceCountry: 'Země narození',
    EXTRACTED_FIELDS_MRZFull: 'Plný MRZ',
    EXTRACTED_FIELDS_MRZLine1: 'Řádek MRZ 1',
    EXTRACTED_FIELDS_MRZLine2: 'MRZ řádek 2',
    EXTRACTED_FIELDS_MRZLine3: 'MRZ řádek 3',
    EXTRACTED_FIELDS_ObservationPage: 'Pozorovací stránka',
    EXTRACTED_FIELDS_IssuingAuthority: 'Vydávající autorita',
    EXTRACTED_FIELDS_IssuingLocation: 'Vydávací místo',
    EXTRACTED_FIELDS_MaritalStatus: 'Rodinný stav',
    EXTRACTED_FIELDS_Occupation: 'Obsazení',
    EXTRACTED_FIELDS_AlienNumber: 'Cizí číslo',
    EXTRACTED_FIELDS_Employer: 'Zaměstnavatel',
    EXTRACTED_FIELDS_AddressLine1: 'Adresa řádek 1',
    EXTRACTED_FIELDS_AddressLine2: 'Adresa řádek 2',
    EXTRACTED_FIELDS_AddressLine3: 'Adresa řádek 3',
    EXTRACTED_FIELDS_AddressLine4: 'Adresa řádek 4',
    EXTRACTED_FIELDS_AddressState: 'Stát',
    EXTRACTED_FIELDS_AddressDistrict: 'Okres',
    EXTRACTED_FIELDS_AddressBuildingNumber: 'Číslo budovy',
    EXTRACTED_FIELDS_AddressBuildingName: 'Název budovy',
    EXTRACTED_FIELDS_AddressStreet: 'Ulice',
    EXTRACTED_FIELDS_AddressCountry: 'Země',
    EXTRACTED_FIELDS_RefAddressFull: 'Referenční adresa',
    EXTRACTED_FIELDS_RefAddressLine1: 'Referenční adresa řádek 1',
    EXTRACTED_FIELDS_RefAddressLine2: 'Odkaz Adresa řádek 2',
    EXTRACTED_FIELDS_RefAddressLine3: 'Referenční adresa řádek 3',
    EXTRACTED_FIELDS_RefAddressLine4: 'Odkaz Adresa řádek 4',
    EXTRACTED_FIELDS_RefAddressCity: 'Reference Adresa Město',
    EXTRACTED_FIELDS_RefAddressState: 'Reference Adresa Stát',
    EXTRACTED_FIELDS_RefAddressDistrict: 'Odkaz Adresa Okres',
    EXTRACTED_FIELDS_RefAddressBuildingNumber: 'Referenční adresa číslo budovy',
    EXTRACTED_FIELDS_RefAddressBuildingName: 'Reference Adresa Název Budovy',
    EXTRACTED_FIELDS_RefAddressSubBuildingName:
        'Reference Adresa Pod Názvem Budovy',
    EXTRACTED_FIELDS_RefAddressStreet: 'Reference Adresa Ulice',
    EXTRACTED_FIELDS_RefAddressCountry: 'Reference Adresa Země',
    EXTRACTED_FIELDS_RefAddressPostCode: 'Odkaz Adresa PSČ',
    EXTRACTED_FIELDS_HealthNumber: 'Zdravotní číslo',
    EXTRACTED_FIELDS_Endorsements: 'Odvody',
    EXTRACTED_FIELDS_Constraints: 'Omezení',
    EXTRACTED_FIELDS_LicenseMarine: 'Licence Marine',
    EXTRACTED_FIELDS_Height: 'Výška',
    EXTRACTED_FIELDS_Weight: 'Váha',
    EXTRACTED_FIELDS_HairColor: 'Barva vlasů',
    EXTRACTED_FIELDS_EyeColor: 'Barva očí',
    EXTRACTED_FIELDS_LensData: 'Zrak',
    EXTRACTED_FIELDS_SocialSecurityNumber: 'Rodné číslo',
    EXTRACTED_FIELDS_NationalInsuranceNumber: 'Číslo národního pojištění',
    EXTRACTED_FIELDS_Race: 'Závod.',
    EXTRACTED_FIELDS_MotherName: 'Jméno matky',
    EXTRACTED_FIELDS_FatherName: 'Jméno otce',
    EXTRACTED_FIELDS_Parents: 'Rodiče',
    EXTRACTED_FIELDS_Remarks: 'Poznámky',
    EXTRACTED_FIELDS_DistinguishingMarks: 'Rozlišovací značky',
    EXTRACTED_FIELDS_PeriodOfStay: 'Doba pobytu',
    EXTRACTED_FIELDS_TaxNumber: 'Daňové číslo',
    EXTRACTED_FIELDS_Donor: 'Darce',
    EXTRACTED_FIELDS_RFIDG1: 'RFID surová data skupina 1',
    EXTRACTED_FIELDS_RFIDG2: 'RFID surová data skupina 2',
    EXTRACTED_FIELDS_RFIDG3: 'Skupina 3 surových dat RFID',
    EXTRACTED_FIELDS_RFIDG15: 'RFID surová data skupina 4',
    EXTRACTED_FIELDS_RFIDSOD: 'RFID Raw Data Skupina 5',
    EXTRACTED_FIELDS_PortraitPhoto: 'Extrahovaný portrétní fotografie',
    EXTRACTED_FIELDS_Title: 'Název',
    EXTRACTED_FIELDS_IssueDate2: 'Druhé datum vydání',
    EXTRACTED_FIELDS_ExpiryDate2: 'Druhé datum vypršení platnosti',
    EXTRACTED_FIELDS_LicenseCategory2: 'Druhá kategorie licence',
    EXTRACTED_FIELDS_IssueDate3: 'Třetí datum vydání',
    EXTRACTED_FIELDS_ExpiryDate3: 'Třetí datum vypršení platnosti',
    EXTRACTED_FIELDS_LicenseCategory3: 'Třetí kategorie licence',
    EXTRACTED_FIELDS_IssueDate4: 'Čtvrté vydání datum',
    EXTRACTED_FIELDS_ExpiryDate4: 'Čtvrté datum vypršení platnosti',
    EXTRACTED_FIELDS_LicenseCategory4: 'Čtvrtá kategorie licence',
    EXTRACTED_FIELDS_MRZCode1: 'Kód MRZ 1',
    EXTRACTED_FIELDS_MRZCode2: 'Kód MRZ 2',
    EXTRACTED_FIELDS_MRZStandardType: 'Standard typ MRZ',
    EXTRACTED_FIELDS_AddressStreetSuffix: 'Ulice Sufix',
    EXTRACTED_FIELDS_AddressStreetType: 'Typ ulice',
    EXTRACTED_FIELDS_AddressUnitNumber: 'Adresa Jednotka Číslo',
    EXTRACTED_FIELDS_LicenseNumber: 'Číslo licence',
    EXTRACTED_FIELDS_AddressStateCode: 'Státní kód',
    EXTRACTED_FIELDS_AddressStreetTypeAbbreviation: 'Ulice Zkratka',
    EXTRACTED_FIELDS_AddressUnitType: 'Typ Jednotka Adresa',
    EXTRACTED_FIELDS_AddressDeliveryPointIdentifier:
        'Identifikátor dodacího místa',
    EXTRACTED_FIELDS_AgeCategory: 'Věková kategorie',
    EXTRACTED_FIELDS_ChildernCount: 'Počet dětí',
    EXTRACTED_FIELDS_EntryMode: 'Režim vstupu',
    EXTRACTED_FIELDS_VAFNumber: 'Číslo VAF',
    EXTRACTED_FIELDS_AddressLine5: 'Adresa řádek 5',
    EXTRACTED_FIELDS_RFIDPortraitPhoto: 'RFID portrétní fotografie',
    EXTRACTED_FIELDS_RefAddressLine5: 'Reference Adresa Řádek 5',
    EXTRACTED_FIELDS_RefAddressStateCode: 'Reference Adresa Stát',
    EXTRACTED_FIELDS_RefAddressStreetType: 'Typ adresy ulice Typ',
    EXTRACTED_FIELDS_RefAddressStreetTypeAbbreviation:
        'Odkaz Adresa Ulice Typ Zkratka',
    EXTRACTED_FIELDS_RefAddressStreetSuffix: 'Reference Adresní Ulice Přípona',
    EXTRACTED_FIELDS_RefAddressUnitNumber: 'Referenční adresa číslo jednotky',
    EXTRACTED_FIELDS_RefAddressUnitType: 'Reference Adresa Jednotka Typ',
    EXTRACTED_FIELDS_RefAddressPostcodeType: 'Odkaz Adresa PSČ Typ',
    EXTRACTED_FIELDS_RefAddressDeliveryPointIdentifier:
        'Identifikátor dodacího místa odkazu na adresu',
    EXTRACTED_FIELDS_RefAddressPOBoxNumber: 'Odkazová adresa PO Box číslo',
    EXTRACTED_FIELDS_RefAddressDependentLocality:
        'Odkaz Adresa Závislá Lokalita',
    EXTRACTED_FIELDS_RefAddressDoubleDependentLocality:
        'Reference Adresa Dvojitá Závislá Lokalita',
    EXTRACTED_FIELDS_RefAddressThoroughfare: 'Odkaz Adresa Thoroughfare',
    EXTRACTED_FIELDS_RefAddressThoroughfareDesc: 'Popis adresy ulice odkazu',
    EXTRACTED_FIELDS_RefAddressDependentThoroughfare:
        'Odkaz Adresa Závislá Thoroughfare',
    EXTRACTED_FIELDS_RefAddressDependentThoroughfareDesc:
        'Popis adresy závislé na adrese.',
    EXTRACTED_FIELDS_RefAddressSubBuildingNumber:
        'Odkaz Adresa Pod Budovou Číslo',
    EXTRACTED_FIELDS_AddressSubBuildingNumber: 'Číslo budovy',
    EXTRACTED_FIELDS_AddressSubBuildingName: 'Název budovy',
    EXTRACTED_FIELDS_AddressPostCodeType: 'Typ PSČ',
    EXTRACTED_FIELDS_IssuingAuthorityType: 'Typ vydávající autority',
    EXTRACTED_FIELDS_Signature: 'Podpis',
    EXTRACTED_FIELDS_Hologram: 'Hologram',
    EXTRACTED_FIELDS_CardNumber: 'Číslo karty',
    EXTRACTED_FIELDS_MiddleNameInitial: 'Střední iniciál jména',
    EXTRACTED_FIELDS_PermitNumber: 'Číslo povolení',
    EXTRACTED_FIELDS_ReferenceNumber: 'Referenční číslo',
    EXTRACTED_FIELDS_CustomerNumber: 'Číslo zákazníka',
    EXTRACTED_FIELDS_BOSNumber: 'Číslo BOS',
    EXTRACTED_FIELDS_StudentID: 'Identifikační číslo studenta',
    EXTRACTED_FIELDS_MembershipNumber: 'Členské číslo',
    EXTRACTED_FIELDS_LicenseType: 'Typ licence',
    EXTRACTED_FIELDS_LicenseType2: 'Typ licence 2',
    EXTRACTED_FIELDS_LicenseType3: 'Typ licence 3',
    EXTRACTED_FIELDS_LicenseType4: 'Typ licence 4',
    EXTRACTED_FIELDS_DocumentTypeCode: 'Typ kódu dokumentu',
    EXTRACTED_FIELDS_MRZDocumentNumberCheckDigit: 'Kontrolní číslice MRZ',
    EXTRACTED_FIELDS_MRZBirthDateCheckDigit:
        'Kontrolní číslice data narození MRZ',
    EXTRACTED_FIELDS_MRZExpiryDateCheckDigit:
        'Kontrolní číslice data vypršení platnosti MRZ',
    EXTRACTED_FIELDS_MRZPersonalNumberCheckDigit:
        'Kontrolní číslice osobního čísla MRZ',
    EXTRACTED_FIELDS_MRZCompositeCheckDigit: 'Kontrolní číslice MRZ Composite',
    EXTRACTED_FIELDS_SecondaryPortraitPhoto: 'Sekundární portrétní fotografie',
    EXTRACTED_FIELDS_Fingerprint: 'Odtisk prstu',
    EXTRACTED_FIELDS_VersionNumber: 'Verze čísla',
    EXTRACTED_FIELDS_Conditions: 'Podmínky',
    EXTRACTED_FIELDS_NickName: 'Přezdívka',
    EXTRACTED_FIELDS_AddressApartmentNumber: 'Bytové číslo',
    EXTRACTED_FIELDS_AddressFloorNumber: 'Číslo podlaží',
    EXTRACTED_FIELDS_FirstNameLocal: 'Jméno Místní',
    EXTRACTED_FIELDS_LastNameLocal: 'Příjmení Místní',
    EXTRACTED_FIELDS_FullNameLocal: 'Plné jméno Místní',
    EXTRACTED_FIELDS_BirthPlaceLocal: 'Místo narození Místní',
    EXTRACTED_FIELDS_IssuingAuthorityLocal: 'Vydávající autorita Místní',
    EXTRACTED_FIELDS_MotherNameLocal: 'Matka Jméno Místní',
    EXTRACTED_FIELDS_FatherNameLocal: 'Otec Jméno Místní',
    EXTRACTED_FIELDS_AddressFullLocal: 'Adresa Plná Místní',
    EXTRACTED_FIELDS_MiddleNameLocal: 'Druhé jméno Místní',
    EXTRACTED_FIELDS_AddressLine1Local: 'Adresa řádek 1 Místní',
    EXTRACTED_FIELDS_AddressLine2Local: 'Adresa řádek 2 Místní',
    EXTRACTED_FIELDS_AddressLine3Local: 'Adresa řádek 3 Místní',
    EXTRACTED_FIELDS_IndRefNumber1: 'Jednotlivé referenční číslo 1',
    EXTRACTED_FIELDS_IndRefNumber2: 'Individuální referenční číslo 2',
    EXTRACTED_FIELDS_IndRefNumber3: 'Individuální referenční číslo 3.',
    EXTRACTED_FIELDS_IndRefNumber4: 'Individuální referenční číslo 4',
    EXTRACTED_FIELDS_IndRefNumber5: 'Jednotlivé referenční číslo 5',
    EXTRACTED_FIELDS_Name1: 'Jméno 1',
    EXTRACTED_FIELDS_Name2: 'Jméno 2',
    EXTRACTED_FIELDS_Name3: 'Jméno 3',
    EXTRACTED_FIELDS_Name4: 'Jméno 4',
    EXTRACTED_FIELDS_Name5: 'Jméno 5',
    EXTRACTED_FIELDS_RECIPIENT_NAME_1: 'Název příjemce 1',
    EXTRACTED_FIELDS_RECIPIENT_NAME_2: 'Jméno příjemce 2',
    EXTRACTED_FIELDS_RECIPIENT_NAME_3: 'Jméno příjemce 3',
    EXTRACTED_FIELDS_RECIPIENT_NAME_4: 'Jméno příjemce 4',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_FULL: 'Adresa příjemce Úplná',
    EXTRACTED_FIELDS_IBAN: 'Číslo účtu IBAN',
    EXTRACTED_FIELDS_ACCOUNT_NUM: 'Číslo účtu',
    EXTRACTED_FIELDS_ISSUER: 'Vydavatel',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_CITY: 'Adresa příjemce Město',
    EXTRACTED_FIELDS_RECIPIENT_ADDRESS_POST_CODE:
        'Adresa příjemce Poštovní směrovací číslo',
    EXTRACTED_FIELDS_DAY: 'Den',
    EXTRACTED_FIELDS_MONTH: 'Měsíc',
    EXTRACTED_FIELDS_YEAR: 'Rok',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_1: 'Nepovinná hodnota 1',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_2: 'Nepovinná hodnota 2',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_3: 'Nepovinná hodnota 3',
    EXTRACTED_FIELDS_OPTIONAL_VALUE_4: 'Nepovinná hodnota 4',
    EXTRACTED_FIELDS_ISSUING_STATE_NAME: 'Název vydávajícího státu',
    EXTRACTED_FIELDS_FRONT_DOCUMENT_TYPE_ID: 'Frontside Document Type Id',
    EXTRACTED_FIELDS_BACK_DOCUMENT_TYPE_ID: 'Id zadní strany typu dokladu',
    HASNOCAMERA_TITLE:
        'Jejda, nepodařilo se nám rozpoznat fotoaparát ve vašem zařízení!',
    HASNOCAMERA_DESCRIPTION:
        'vypadá to, že vaše zařízení nemá fotoaparát, zkuste to prosím znovu na jiném zařízení, které má funkční fotoaparát, abyste mohli provést všechny požadované kroky.',
    EXTRACTED_FIELDS_COVIDPASSCROSSCHECKRESULT: 'Covid Type Id',
    USER_INPUT_FIRST_NAME: 'Jméno',
    USER_INPUT_MIDDLE_NAME: 'Střední jméno',
    USER_INPUT_LAST_NAME: 'Příjmení',
    USER_INPUT_DOB: 'Datum narození',
    USER_INPUT_HOUSE_NAME_NUMBER: 'Jméno/číslo domu*',
    USER_INPUT_STREET_NAME: 'Název ulice*',
    USER_INPUT_TOWN: 'Město*',
    USER_INPUT_POSTAL_CODE: 'Poštovní směrovací číslo*',
    USER_INPUT_HOUSE_NAME_NUMBER_EXAMPLE: 'Např. dům/35',
    USER_INPUT_STREET_NAME_EXAMPLE: 'Např. Testovací ulice',
    USER_INPUT_TOWN_EXAMPLE: 'Např. Somewhere',
    USER_INPUT_POSTAL_CODE_EXAMPLE: 'např. CH496 (bez mezer)',
    SYSTEM_NOT_ABLE: 'Systém nemohl naskenovat dokument',
    TRY_AGAIN: 'Zkuste to znovu',
    HINTS_DISABLED_HEADER: 'Nápovědy jsou v ručním režimu vypnuty',
    HINTS_DISABLED_DESCRIPTION:
        'Pokud chcete povolit nápovědy pro pořízení fotografie, přepněte na režim AUTOMATICKÉHO ZACHYCENÍ',
    YOU_HAVE: 'Máte',
    PICTURE_VERIFYING: 'Ověřování...',
    HOW_TO_TAKE_PHOTO_CORRECTLY: 'Jak správně pořídit fotografii',
};
